<template>
    <Pagebuilder type="page" :id="config.public.sanityHomeId" />
</template>

<script setup lang="ts">
    import { overwriteLatestPageHistory } from '~/composables/usePageHistoryStorage';

    const gtm = useGtm();
    const config = useRuntimeConfig();
    const route = useRoute();
    const pageDataStore = usePageDataStore();
    const snippetsStore = useSnippetsStore();
    const snippets = snippetsStore.snippets;
    const { search } = useCategorySearch();

    function triggerEvent() {
        gtm?.trackView('Home', '/nl/');
    }

    onBeforeMount(() => {
        triggerEvent();
        overwriteLatestPageHistory({
            key: route.path,
            url: route.fullPath,
            type: 'home',
        });
    });

    const data = ref({});
    data.value.context = 'general';

    onMounted(() => {
        pageDataStore.setData(data.value);
    });

    const pageData = await search(config.public.shopwareHomeId);

    useHead({
        title: 'Home ' + snippets['headless.metatitle'] || ' | Ballegooyen Modes',
        link: [
            {
                rel: 'canonical',
                href: `${config.public.prodUrl}/nl/`,
            },
        ],
        meta: [
            {
                name: 'description',
                content: pageData?.translated?.metaDescription,
            },
        ],
    });
</script>
